import React from 'react';

import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import scalerLeaf from 'assets/icons/scalerLeaf.svg';
import styles from './Footer.module.scss';

function Footer() {
  return (
    <>
      <ElementSpacePlaceholder elementId="course-management-page-footer" />
      <div
        id="course-management-page-footer"
        className={styles.root}
      >
        <div>Powered By</div>
        <img
          src={scalerLeaf}
          alt="scaler-logo"
          className="h5"
        />
      </div>
    </>
  );
}

export default Footer;
